export default "__VITE_ASSET__Dwq3oETq__"